var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 24,
    viewBox: "0 0 49 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4126 23.1003C15.4137 23.1003 17.2435 19.7154 17.8229 18.1296H19.2561C18.6767 19.3189 18.0668 21.0266 18.0668 22.6734H21.0248V12.1526H10.504V14.9581H17.8838C17.7009 17.5197 15.4137 20.3253 11.2969 20.3253C7.02761 20.3253 4.03909 17.2757 4.03909 11.9696C4.03909 6.54149 7.66801 3.73594 11.4189 3.73594C15.0173 3.73594 16.9385 5.74862 17.9753 8.55416L21.0858 7.30386C19.988 4.07139 16.908 0.899902 11.4799 0.899902C5.62484 0.899902 0.776123 5.44367 0.776123 12.0001C0.776123 18.831 4.77098 23.1003 10.4126 23.1003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.524 22.9911V11.9214C28.524 8.68889 27.8531 6.1883 27.0297 4.26711L28.3105 3.77918L35.8123 22.9911H37.9775L45.3878 3.77918L46.6685 4.26711C45.8757 6.1883 45.1743 8.68889 45.1743 11.9214V22.9911H48.2238V1.64453H43.2226L38.5874 13.8731C37.825 15.8552 37.642 17.197 37.6115 19.5146H36.3002C36.2697 17.2275 36.0868 15.7637 35.3549 13.8731L30.5977 1.64453H25.4745V22.9911H28.524Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.45b0327bc6e952455612cefdd15cbd92.svg";
export { ForwardRef as ReactComponent };